import React from 'react'
import LoginPage from '../component/LoginPage'

const Login = () => {
  return (
   <>
    
    <LoginPage/>
   </>
  )
}

export default Login